module.exports = __webpack_public_path__ + "rfm-avatar-lost.svg?5a1dbbd54669ee24cdc088d2b443970f";